import { createApiSlice } from 'app/createApiSlice'

export const notifInboxApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'notifInbox/api',

  endpoints(builder) {
    return {
      fetchNotif: builder.query({
        query({ page = 0, size = 10 }) {
          return `/api/v1/bussines/notification?page=${page}&size=${size}`
        },
      }),
      fetchInbox: builder.query({
        query({ page = 0, type, size = 10 }) {
          return `/api/v1/bussines/notification-news?page=${page}&type=${type}&size=${size}`
        },
      }),
    }
  },
})

export const { useFetchNotifQuery, useFetchInboxQuery } = notifInboxApiSlice
